/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=78630ce9&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=78630ce9&scoped=true&lang=css"

import exportComponent from "D:\\project\\cloudbirds-support\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78630ce9"]])

export default __exports__